import React from "react";
import Link from "next/link";
import { useSelector } from "react-redux";

import { getDomainCountryCode } from "redux/selectors/config";
import { getCurrentDispensary } from "redux/selectors/dispensary";
import { getDispensaryReviews } from "redux/selectors/reviews";
import { dispensaryHref } from "utils/dispensaryUrls";
import { trackMenuEvent } from "utils/trackEvent";

import ReviewContainer from "components/Dispensary/Reviews/components/ReviewContainer";
import ReviewsHeader from "components/Dispensary/ReviewsHeader";

const ReviewsOverview: React.FC = () => {
  const { slug, name, retailType } = useSelector(getCurrentDispensary);
  const { reviews } = useSelector(getDispensaryReviews);
  const countryCode = useSelector(getDomainCountryCode);

  const onClick = () => {
    trackMenuEvent("Click", "See all Reviews Button");
  };

  const href = dispensaryHref({
    additionalPath: "/reviews",
    countryCode,
    retailType,
    slug,
  });

  return (
    <div id="reviews-overview">
      <ReviewsHeader />
      {reviews && reviews.length > 0 && (
        <>
          <div className="mt-lg">
            {/* eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate */}
            {reviews.slice(0, 4).map((review: any) => (
              <ReviewContainer
                review={{ ...review, itemReviewed: name }}
                key={review.id}
              />
            ))}
          </div>
          <Link
            prefetch={false}
            href={href}
            className="button button--tertiary bg-green block text-sm text-white"
            data-testid="reviews-overview-see-all"
            onClick={onClick}
          >
            see all reviews
          </Link>
        </>
      )}
    </div>
  );
};

export default ReviewsOverview;
